import { CryptoDepositsUnavailableModalCallable } from 'app/_authenticated/funds/components/CryptoDepositsUnavailableModal';
import { OrderTypeModalCallable } from 'app/_authenticated/trade/components/OrderTypeModal/OrderTypeModal';
import { AiInsightsModalCallable } from 'components/AiInsights/AiInsightsBottomSheet';
import { InfoModalCallable } from 'components/InfoModal/InfoModal';

export function CallableRoot() {
  return (
    <>
      <OrderTypeModalCallable.Root />
      <InfoModalCallable.Root />
      <AiInsightsModalCallable.Root />
      <CryptoDepositsUnavailableModalCallable.Root />
    </>
  );
}
